// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReusableButton.module.css */
.MuiButtonBase-root.secondaryButton {
    background-color: transparent;
    text-transform: capitalize;
    color: #fff;
    font-weight: 400;
    border: none; 
    font-family: var(--font-family-primary);
    border-radius: 5px;
    height: 44px;
    min-height: 44px;
    /* min-width: 140px !important; */
    max-width: 100%;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border: 1px solid rgba(255, 255, 255, 1);
    font-size: 1rem;
    line-height: 1.2;
}
.MuiButtonBase-root.secondaryButton:hover {
    background-color: transparent;
}
.MuiButtonBase-root.secondaryButton:disabled {
    background-color: #262839;
    color: rgba(253, 252, 255, 0.3);
    border: none;
}
.MuiButtonBase-root.secondaryButton:focus-visible {
    outline: none;
    offset: 0px;
}
.Mui-disabled.secondaryButton .buttonIcon .MuiSvgIcon-root {
    color: rgba(253, 252, 255, 0.3) !important;
}

.buttonIcon{
    /* width: 100%; */
    height: 100%;
    display: flex;
    align-items: center;
}

@media (max-width: 600px) {
    .MuiButtonBase-root.styledButton,
    .MuiButtonBase-root.nonStyledbtn {
        min-width: 100px;
        font-size: 0.95rem;
        padding: 0 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/SecondaryButton/SecondaryButton.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,YAAY;AAChB;AACA;IACI,aAAa;IACb,WAAW;AACf;AACA;IACI,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;;QAEI,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;IACnB;AACJ","sourcesContent":["/* ReusableButton.module.css */\n.MuiButtonBase-root.secondaryButton {\n    background-color: transparent;\n    text-transform: capitalize;\n    color: #fff;\n    font-weight: 400;\n    border: none; \n    font-family: var(--font-family-primary);\n    border-radius: 5px;\n    height: 44px;\n    min-height: 44px;\n    /* min-width: 140px !important; */\n    max-width: 100%;\n    padding: 0 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    box-sizing: border-box;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    border: 1px solid rgba(255, 255, 255, 1);\n    font-size: 1rem;\n    line-height: 1.2;\n}\n.MuiButtonBase-root.secondaryButton:hover {\n    background-color: transparent;\n}\n.MuiButtonBase-root.secondaryButton:disabled {\n    background-color: #262839;\n    color: rgba(253, 252, 255, 0.3);\n    border: none;\n}\n.MuiButtonBase-root.secondaryButton:focus-visible {\n    outline: none;\n    offset: 0px;\n}\n.Mui-disabled.secondaryButton .buttonIcon .MuiSvgIcon-root {\n    color: rgba(253, 252, 255, 0.3) !important;\n}\n\n.buttonIcon{\n    /* width: 100%; */\n    height: 100%;\n    display: flex;\n    align-items: center;\n}\n\n@media (max-width: 600px) {\n    .MuiButtonBase-root.styledButton,\n    .MuiButtonBase-root.nonStyledbtn {\n        min-width: 100px;\n        font-size: 0.95rem;\n        padding: 0 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
